<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="card-body">
      <div class="row">
          <div class="col-sm-12 col-xl-12 form-group m-form__group">
              <div class="card shadow shadow-showcase">
                  <div class="card-body row" style="margin-top:30px;">
                      <div class="col-sm-6 col-xl-6 form-group m-form__group">
                          <label>Contractor Mobile Number</label>
                          <span class="text-danger">*</span>
                          <div class="input-group">
                              <div class="input-group-prepend">
                                  <span class="input-group-text"><i class="icofont icofont-user"></i></span>
                              </div>
                              <input autofocus formControlName="mobileNumber" type="text" class="form-control" placeholder="Contractor Mobile Number" required>
                          </div>
                          <div *ngIf="form.controls.mobileNumber.invalid && (form.controls.mobileNumber.dirty || form.controls.mobileNumber.touched)" class="text text-danger">
                              <div *ngIf="form.controls.mobileNumber.errors.required">
                                  Contractor Mobile Number is required
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6 col-xl-6 form-group m-form__group"></div>
                      <div class="col-sm-6 col-xl-6 form-group m-form__group">
                          <label >Enter QR Code</label>
                          <span class="text-danger">*</span>
                          <div class="input-group">
                              <div class="input-group-prepend">
                                  <span class="input-group-text"><i class="icofont icofont-user"></i></span>
                              </div>
                              <input autofocus formControlName="qrCode" type="text" class="form-control" placeholder="Enter QR Code">
                          </div>
                          <div *ngIf="form.controls.qrCode.invalid && (form.controls.qrCode.dirty || form.controls.qrCode.touched)" class="text text-danger">
                              <div *ngIf="form.controls.qrCode.errors.required">
                                  QR Code is required
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-6 col-xl-6 form-group m-form__group"></div>
                  </div>
                  <div class="card-footer" style="text-align:right;">
                    <div class="row">
                      <div class="col-sm-6 col-xl-6 form-group m-form__group">
                        <button type="submit" class="btn btn-primary">Save</button>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</form>